import { useEffect, useState } from "react";
import ContainerContent from "../Container/ContainerContent";
import CSVReader from "react-csv-reader";
import Lottie from "react-lottie";
import Loading from "../../animation/loading.json";
import axios from "axios";
import Button from "../Leasing/components/leasing.c.button";
import ReactExport from "react-data-export";
import { format } from "date-fns";
import { getCurrentLocalDateTime } from "../../utils/getLocalDateTime";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const importOptions = {
  header: true,
  dynamicTyping: true,
  skipEmptyLines: true,
};

function ImportTriggerAccrued() {
  const [loading, setLoading] = useState(false);
  const [loadingQuery, setLoadingQuery] = useState(false);
  const [accruedItems, setAccruedItems] = useState([]);
  const [isClick, setIsClick] = useState(false);
  const [date, setDate] = useState(getCurrentLocalDateTime().fullDate);

  useEffect(() => {
    const docId = document.getElementById("importAccured");
    if (docId && isClick) {
      docId.click();
      setIsClick(false);
    }
  }, [isClick]);

  const onImportAccrued = async (files) => {
    try {
      setLoading(true);

      console.log("files", files);

      if (files?.length === 0) {
        alert("ไม่พบข้อมูลในไฟล์ CSV");
        return;
      }

      for (const file of files) {
        await axios.post(
          "https://v5vk66dyrgux5vu37e32v4khnq0wovrk.lambda-url.ap-southeast-1.on.aws",
          {
            ...file,
          }
        );
      }
      alert("บันทึกข้อมูลสำเร็จ");
    } catch (error) {
      alert(error);
    } finally {
      setLoading(false);
    }
  };

  const onClickImportAccroed = async () => {
    try {
      setLoadingQuery(true);

      const INT_ACCRUE_DOC_DATE = String(date).split("-").join("");

      const items = await axios.get(
        "https://v5vk66dyrgux5vu37e32v4khnq0wovrk.lambda-url.ap-southeast-1.on.aws",
        {
          params: {
            INT_ACCRUE_DOC_DATE: INT_ACCRUE_DOC_DATE,
          },
        }
      );
      setAccruedItems(items?.data);
      setIsClick(true);
    } catch (error) {
    } finally {
      setLoadingQuery(false);
    }
  };

  const style = {
    font: { sz: 16, name: "Cordia New" },
    alignment: { vertical: "center", horizontal: "center" },
  };

  const createDataWithStyleAll = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    const style = {
      font: { sz: 14 },
      alignment: { vertical: "center", horizontal: "center" },
      // border: borders,
    };

    for (let i = 0; i < data.length; i++) {
      result.push([
        {
          value: data[i]?.REFERENCE || "",
          style,
        },
        {
          value: data[i]?.ID || "",
          style,
        },
        {
          value: data[i]?.TAX_ID || "",
          style,
        },
        {
          value: data[i]?.ACCR_INTEREST_RECEIVABLE || "",
          style,
        },
        {
          value: data[i]?.CONTRACT_TYPE || "",
          style,
        },
        {
          value: data[i]?.INT_ACCRUE_DOC_DATE || "",
          style,
        },
        {
          value: data[i]?.MESSAGE || "",
          style,
        },
        {
          value: data[i]?.MESSAGE_TYPE || "",
          style,
        },
        {
          value: format(new Date(data[i]?.createdAt), "dd-MM-yyyy HH:mm") || "",
          style,
        },
      ]);
    }
    return result;
  };

  const multiDataSetAll = [
    {
      columns: [
        {
          title: "REFERENCE",
          width: { wch: 28 },
          style,
        },
        {
          title: "ID",
          width: { wch: 28 },
          style,
        },
        {
          title: "TAX_ID",
          width: { wch: 28 },
          style,
        },
        {
          title: "ACCR_INTEREST_RECEIVABLE",
          width: { wch: 28 },
          style,
        },
        {
          title: "CONTRACT_TYPE",
          width: { wch: 28 },
          style,
        },
        {
          title: "INT_ACCRUE_DOC_DATE",
          width: { wch: 28 },
          style,
        },
        {
          title: "MESSAGE",
          width: { wch: 50 },
          style,
        },
        {
          title: "MESSAGE_TYPE",
          width: { wch: 28 },
          style,
        },
        {
          title: "วันที่สร้าง",
          width: { wch: 28 },
          style,
        },
      ],
      data: createDataWithStyleAll(accruedItems),
    },
  ];

  return (
    <ContainerContent>
      <div className="mx-4 w-full mb-2 lg:flex items-center">
        {loading && (
          <div className="fixed z-10 inset-0 overflow-y-auto bg-black bg-opacity-70 backdrop-filter backdrop-blur-sm flex justify-center items-center    ">
            <div className="w-2/5 h-auto mx-auto  ">
              <Lottie
                options={{
                  loop: true,
                  autoplay: true,
                  animationData: Loading,
                  isStopped: false,
                  isPaused: false,
                  rendererSettings: {
                    preserveAspectRatio: "xMidYMid slice",
                  },
                }}
              />
              <div className="text-center text-white text-xl">
                กำลัง Sync ข้อมูล CSV กับ Transactions{" "}
              </div>
            </div>
          </div>
        )}
        <div className="mx-4  p-2 lg:flex bg-gray-50 mb-2 border border-gray-200">
          <div className="ml-2 flex flex-row space-x-4">
            <label className="my-auto font-bold text-gray-700">
              Import Accrued
            </label>
            <CSVReader
              parserOptions={importOptions}
              onFileLoaded={onImportAccrued}
            />
          </div>{" "}
        </div>
        <input
          value={date}
          onChange={(e) => setDate(e?.target?.value)}
          type="date"
          className="p-2 py-1 border rounded shadow-sm mr-2"
        />
        <Button className="bg-green-500 rounded" onClick={onClickImportAccroed}>
          Report Accrued
        </Button>
        <ExcelFile
          filename={`IMPORT_ACCRUED_${format(new Date(), "yyyy-MM-dd")}`}
          element={<button id="importAccured" hidden></button>}
        >
          <ExcelSheet
            dataSet={multiDataSetAll}
            name="IMPORT_ACCRUED"
          ></ExcelSheet>
        </ExcelFile>
      </div>
    </ContainerContent>
  );
}

export default ImportTriggerAccrued;
